module.exports = __webpack_public_path__ + "static/img/slide_9_en.a437de5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/training/slider/slide_9_en.svg
// module id = lQ4+
// module chunks = 0